export const invalidacaoRespostasMixin = () => {
    return {
        data() {
            return {
                labelInvalidado: 'Invalidada',
                labelInvalidar: 'Invalidar',
                labelRevalidar: 'Revalidar',
                labelInvalidarPergunta: 'Invalidar pergunta',
                labelRevalidarPergunta: 'Revalidar pergunta',
                labelInvalidarFormulario: 'Invalidar respondente',
                labelRevalidarFormulario: 'Revalidar respondente',
                labelInvalidarBloco: 'Invalidar bloco',
                labelRevalidarBloco: 'Revalidar bloco',
                labelInvalidarProjeto: 'Invalidar projeto',
                labelRevalidarProjeto: 'Revalidar projeto',
                labelAlertaPerguntaInvalidade: 'Pergunta foi invalidada',
            }
        },
        computed: {
            podeAlterarInvalidacao() {
                return !!window.impersonating
            },
        },
        methods: {
            invalidaOpcao: function () {
                throw new Error("invalidaOpcao não está definido para este tipo de pergunta")
            },
            revalidaOpcao: function () {
                throw new Error("invalidaOpcao não está definido para este tipo de pergunta")
            },

            invalidaCampo(campoId) {
                axios.get(this.getInvalidarCampoUrl(campoId)).then(
                    () => {
                        this.perguntaInvalidada = true
                    }
                ).catch(
                    (error) =>{
                        alert('Houve um problema ao invalidar essa pergunta,tente novamente mais tarde!');
                        throw new Error(`erro ao invalidar campo.id= '${this.respostas.id}', error=${JSON.stringify(error)}`)
                    }
                )
            },
            revalidaCampo(campoId) {
                axios.get(this.getRevalidarCampoUrl(campoId)).then(
                    () => {
                        this.perguntaInvalidada = false
                    }
                ).catch(
                    (error) =>{
                        alert('Houve um problema ao revalidar essa pergunta,tente novamente mais tarde!');
                        throw new Error(`erro ao revalidar campo.id= '${this.respostas.id}', error=${JSON.stringify(error)}`)
                    }
                )
            },

            exibeInvalidacaoOpcaoNaoSabe(){
                return false
            },
            exibeRevalidacaoOpcaoNaoSabe(){
                return false
            },
            exibeInvalidacaoOpcaoNaoSeAplica(){
                return false
            },
            exibeRevalidacaoOpcaoNaoSeAplica(){
                return false
            },

            getInvalidarOpcaoUrl(respostaOpcaoId) {
                return `/api/invalidacao/alternativa/${respostaOpcaoId}`;
            },
            getRevalidarOpcaoUrl(respostaOpcaoId) {
                return `/api/revalidacao/alternativa/${respostaOpcaoId}`;
            },
            getInvalidarCampoUrl(respostaCampoId) {
                return `/api/invalidacao/campo/${respostaCampoId}`;
            },
            getRevalidarCampoUrl(respostaCampoId) {
                return `/api/revalidacao/campo/${respostaCampoId}`;
            },
            getInvalidarBlocoUrl(respostaBlocoId) {
                return `/api/invalidacao/bloco/${respostaBlocoId}`;
            },
            getRevalidarBlocoUrl(respostaBlocoId) {
                return `/api/revalidacao/bloco/${respostaBlocoId}`;
            },
            getInvalidarProjetoUrl(respostaProjetoId) {
                return `/api/invalidacao/projeto/${respostaProjetoId}`;
            },
            getRevalidarProjetoUrl(respostaProjetoId) {
                return `/api/revalidacao/projeto/${respostaProjetoId}`;
            },
            getInvalidarFormularioUrl() {
                return `/api/invalidacao/formulario`;
            },
            getRevalidarFormularioUrl() {
                return `/api/revalidacao/formulario`;
            },
        },
    }
}
